// extracted by mini-css-extract-plugin
export default {"avatar":"FallbackAvatar_avatar__7GNR3"};